import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    footerRoot: {
        marginTop: '48px',
        backgroundColor: theme.palette.primary.dark,
        borderTop: `3px solid ${theme.palette.secondary.main}`,
    },
    footerContainer: {
        display: 'flex',
        justifyContent: 'space-evenly',
        flexWrap: 'wrap',
    },
    footerSection1: {
        order: '1',
        minHeight: '200px',
        justifyContent: 'space-between',
        textAlign: 'center',
        paddingBottom: '20px'
    },
    footerSection2: {
        order: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '100%',
        padding: '15px',
        justifyContent: 'center'
    },
    footerTagline: {
        color: 'rgba(247, 244, 236, 0.7)',
        fontSize: '0.9rem',
        marginTop: '8px',
        textAlign: 'center',
    },
    footerLink: {
        display: 'block',
        padding: '12px',
        whiteSpace: 'nowrap',
        color: 'rgba(247, 244, 236, 0.85)',
        textDecoration: 'none',
        fontSize: '0.92rem',
        '&:hover': {
            color: '#FFFFFF',
            textDecoration: 'underline',
        },
    },
    imageContainer: {
        display: "flex",
        alignItems: "center",
        alignSelf: 'center',
        textDecoration: "none",
        padding: '10px'
    },
    title: {
        display: "block",
        textDecoration: "none",
    },
    footerHeader: {
        color: theme.palette.secondary.light,
    },
    footerBottomBar: {
        borderTop: '1px solid rgba(247, 244, 236, 0.15)',
        padding: '16px',
        textAlign: 'center',
    },
    footerCopyright: {
        color: 'rgba(247, 244, 236, 0.6)',
    },
}));
